import { useState } from 'react';
import './navigation.css';
export const Navigation = () => {
  const [ subMenuDisplayed1, setSubMenuDisplayed1 ] = useState(false);
  const [ subMenuDisplayed2, setSubMenuDisplayed2 ] = useState(false);
  const [ subMenuDisplayed3, setSubMenuDisplayed3 ] = useState(false);
  return (
    <nav id='menu' className='navbar navbar-default navbar-fixed-top'>
      <div className='container'>
        <div className='navbar-header'>
          <button
            type='button'
            className='navbar-toggle collapsed'
            data-toggle='collapse'
            data-target='#bs-example-navbar-collapse-1'
          >
            {' '}
            <span className='sr-only'>Toggle navigation</span>{' '}
            <span className='icon-bar'></span>{' '}
            <span className='icon-bar'></span>{' '}
            <span className='icon-bar'></span>{' '}
          </button>
          <a className='navbar-brand page-scroll' href='/#home'>
            <img className="main-header-logo" src="img/logo.svg" alt="Logo"/>
          </a>{' '}
        </div>

        <div
          className='collapse navbar-collapse'
          id='bs-example-navbar-collapse-1'
        >
          <ul className='nav navbar-nav navbar-right'>
            <li>
              <a href='/#asset' className='page-scroll'>
                The Asset
              </a>
            </li>
            <li onMouseOver={()=>{setSubMenuDisplayed1(true)}} onMouseLeave={()=>{setSubMenuDisplayed1(false)}}>
                <span className='menu-span-option'>Technology<svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.33325 1.25L5.99992 5.91667L10.6666 1.25" stroke="black" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"/></svg></span>
                <div className='sub-menu' style={{display: subMenuDisplayed1 ? 'block' : 'none'}}>
                  <ul>
                    <li>
                      <a href='/technology' className='page-scroll'>
                        Security
                      </a>
                    </li>
                    <li>
                      <a href='/#tokenomics' className='page-scroll'>
                        Tokenomics
                      </a>
                    </li>
                  </ul>
                </div>
            </li>
            <li onMouseOver={()=>{setSubMenuDisplayed2(true)}} onMouseLeave={()=>{setSubMenuDisplayed2(false)}}>
                <span className='menu-span-option'>About Us<svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.33325 1.25L5.99992 5.91667L10.6666 1.25" stroke="black" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"/></svg></span>
                <div className='sub-menu' style={{display: subMenuDisplayed2 ? 'block' : 'none'}}>
                  <ul>
                    <li>
                      <a href='/about' className='page-scroll'>
                        Specimen Labs
                      </a>
                    </li>
                    <li>
                      <a href='/about#team' className='page-scroll'>
                        Team
                      </a>
                    </li>
                    <li>
                      <a href='#contact' className='page-scroll'>
                        Contact Us
                      </a>
                    </li>
                  </ul>
                </div>
            </li>
            <li>
              <a href='/#roadmap' className='page-scroll'>
                Roadmap
              </a>
            </li>
            <li>
              <a href='/foundations' className='page-scroll'>
                Key Foundations
              </a>
            </li>
            <li onMouseOver={()=>{setSubMenuDisplayed3(true)}} onMouseLeave={()=>{setSubMenuDisplayed3(false)}}>
              <span className='menu-span-option'>Docs<svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.33325 1.25L5.99992 5.91667L10.6666 1.25" stroke="black" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"/></svg></span>
              <div className='sub-menu' style={{display: subMenuDisplayed3 ? 'block' : 'none'}}>
                <ul>
                  <li>
                    <a href='/' className='page-scroll'>
                      About The Gem
                    </a>
                  </li>
                  <li>
                    <a href='/RubyRock_Litepaper_v1.pdf'  target="_blank">
                      LitePaper
                    </a>
                  </li>
                </ul>
              </div>
            </li>
            <li>
              <a href='/ngo' className='page-scroll'>
                NGO
              </a>
            </li>
            <li>
              <a href='/#faq' className='page-scroll'>
                FAQ
              </a>
            </li>
            <li>
              <a href='/whitelist' className='page-scroll header-button'>
                Whitelist
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  )
}
